function showProductReplacementPopup(shipmentNumber, clickedBtn, currentItem, isAltService, shipmentTrackingNumber) {
  const popup = document.getElementById('product-replacement-popup');
  let confirmButton = document.getElementById('confirm-replacement');
  const afterContainer = document.querySelector('.product-replacement-after');
  const beforeContainer = popup.querySelector('.product-replacement-before');

  // Replace the button to remove old listeners
  const newButton = confirmButton.cloneNode(true);
  confirmButton.replaceWith(newButton);
  confirmButton = newButton;

  const updateContainer = (container, item, bannerText) => {
    container.innerHTML = '';
    if (item.img) container.appendChild(item.img);
    if (item.name) container.appendChild(item.name);
    if (item.price) container.appendChild(item.price);
    const banner = document.createElement('div');
    banner.className = `product-replacement-${bannerText}-banner`;
    banner.textContent = bannerText === 'after' ? currentTexts.newService : currentTexts.oldService;
    container.appendChild(banner);
  };

  if (clickedBtn.closest('.product-card')) {
    const productCard = clickedBtn.closest('.product-card');
    const img = productCard.querySelector('img')?.cloneNode(true);
    const name = productCard.querySelector('.product-name')?.cloneNode(true);
    const price = productCard.querySelector('.product-price')?.cloneNode(true);
    if (price) price.textContent = currentTexts.price + ` ${price.textContent}`;
    updateContainer(afterContainer, {img, name, price}, 'after');
  }

  if (currentItem) {
    const currentPrice = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(currentItem.price / 100);
    const img = Object.assign(document.createElement('img'), {
      src: currentItem.image,
      alt: currentItem.product_title,
      className: 'product-image',
    });
    const name = Object.assign(document.createElement('div'), {
      className: 'product-name',
      textContent: currentItem.product_title,
    });
    const price = Object.assign(document.createElement('div'), {
      className: 'product-price',
      textContent: currentTexts.price + ` ${currentPrice}`,
    });
    updateContainer(beforeContainer, {img, name, price}, 'before');
  }

  ['cancel-replacement', 'popup-close', 'popup-overlay'].forEach(selector => {
    popup.querySelector(`.${selector}`).addEventListener('click', () => {
      closePopup(popup.id);
    });
  });

  confirmButton.addEventListener('click', async () => {
    confirmButton.classList.add('loading-button');
    confirmButton.disabled = true;
    await performCartAddition(shipmentNumber, clickedBtn, currentItem, isAltService, shipmentTrackingNumber);
    confirmButton.classList.remove('loading-button');
    confirmButton.disabled = false;
    closePopup(popup.id);
  });

  openPopup(popup.id);
}

function showSlotReplacementPopup(shipmentNumber, slotFromCart, selectedSlot, shipmentTrackingNumber) {
  const popup = document.getElementById('slot-replacement-popup');
  let confirmButton = document.getElementById('confirm-slot-replacement');
  const afterContainer = popup.querySelector('.product-replacement-after');
  const beforeContainer = popup.querySelector('.product-replacement-before');

  // Replace the button to remove old listeners
  const newButton = confirmButton.cloneNode(true);
  confirmButton.replaceWith(newButton);
  confirmButton = newButton;

  if (selectedSlot) {
    afterContainer.innerHTML = '';
    const banner = document.createElement('div');
    banner.textContent = currentTexts.newSlot;
    banner.className = `product-replacement-after-banner`;
    const description = document.createElement('div');
    description.className = 'slot-description';
    description.innerHTML = `<div>${selectedSlot.date}</div><div>${selectedSlot.timeFrom} - ${selectedSlot.timeTo}</div>`;
    afterContainer.appendChild(description);
    afterContainer.appendChild(banner);
  }

  if (slotFromCart) {
    beforeContainer.innerHTML = '';
    const oldDate = slotFromCart.properties['Datum'];
    const oldTime = slotFromCart.properties['Zeitfenster'];

    const banner = document.createElement('div');
    banner.className = `product-replacement-before-banner`;
    banner.textContent = currentTexts.oldSlot;

    const description = document.createElement('div');
    description.className = 'slot-description';
    description.innerHTML = `<div>${oldDate}</div><div>${oldTime}</div>`;

    beforeContainer.appendChild(description);
    beforeContainer.appendChild(banner);
  }

  ['cancel-slot-replacement', 'popup-close', 'popup-overlay'].forEach(selector => {
    popup.querySelector(`.${selector}`).addEventListener('click', () => {
      closePopup(popup.id);
    });
  });

  confirmButton.addEventListener('click', async () => {
    confirmButton.classList.add('loading-button');
    confirmButton.disabled = true;
    await addSlotToCart(shipmentNumber, slotFromCart, selectedSlot, shipmentTrackingNumber);
    confirmButton.classList.remove('loading-button');
    confirmButton.disabled = false;
    closePopup(popup.id);
  });

  openPopup(popup.id);
}

async function performCartAddition(shipmentNumber, button, existingService, isAltService = false, shipmentTrackingNumber) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        attributes: {
          shipmentNumber: shipmentNumber,
          shipmentTrackingNumber: shipmentTrackingNumber},
        items: [{
          id: Number(button.dataset.variantId),
          quantity: 1,
          properties: {
            "Zusatzservice für": button.dataset.serviceFor,
            _articleNumbers: button.dataset.articleNumbers,
            _contractorItemReference: button.dataset.contractorItemReference,
            _service_type: isAltService ? "ALT" : "Standard",
            _productTag: button.dataset.bundleId,
            _cutoff: button.dataset.cutoff || ''
          }
        }]
      })
    });


    if (!response.ok) throw new Error("Failed to add to cart");
    if (existingService) {
      await cartStateManager.removeServiceFromCart(existingService);
    }
    await cartStateManager.updateCartState();
    await refreshCartDrawer(true);
    await updateCartCount();
    document.dispatchEvent(new CustomEvent("cart:updated"));

  } catch (error) {
    console.error("Error adding to cart:", error);
    showSnackbar("Service konnte nicht hinzugefügt werden. Bitte später erneut versuchen.");
  }
}

async function refreshCartDrawer(open = false) {
  try {
    const response = await fetch("/?section_id=cart-drawer");
    const html = await response.text();

    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = html;

    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
      const newCartDrawer = tempContainer.querySelector("cart-drawer");

      if (newCartDrawer) {
        cartDrawer.innerHTML = newCartDrawer.innerHTML;
        cartDrawer.classList.remove("is-empty");
        if (open) {
          cartDrawer.classList.add("active");
          document.body.classList.add("overflow-hidden");
        } else {
          cartDrawer.classList.remove("active");
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  } catch (error) {
    console.error("Error refreshing cart drawer:", error);
  }
}

function getLanguageTexts() {
  const shopifyLocale =
    window.Shopify?.locale ||
    document.documentElement.lang ||
    navigator.language ||
    "en";
  const language = shopifyLocale.split("-")[0].toLowerCase();

  const texts = {
    de: {
      noServicesAvailableBanner: "Momentan sind keine Serviceleistungen verfügbar.",
      noServicesAvailable: "keine Serviceleistungen verfügbar",
      ourServices: "Unsere Serviceleistungen für Ihre Lieferung",
      deliveryTimeUnknown: "Liefertermin nicht bekannt",
      freeSlots: "freie Termine",
      oneFreeSlot: "freier Termin",
      alreadyBought: "Bereits gekauft",
      newService: "neuer Service",
      oldService: "alter Service",
      newSlot: "neuer Termin",
      oldSlot: "alter Termin",
      slotReserved: "Im Warenkorb",
      slotToCart: "Wunschtermin sichern",
      price: "Preis:",
      cartError: "Warenkorb-Fehler",
      addToCart: "In den Warenkorb",
      inCart: "Im Warenkorb",
      notBookable: "Nicht bestellbar",
      serviceBooked: "Service gebucht",
      adding: "Wird hinzugefügt...",
      itemAdded: "Artikel zum Warenkorb hinzugefügt!",
      loading: "Lädt...",
      errorLoading:
        "Leider ist ein Fehler beim Laden der Services aufgetreten.",
      errorLoadingData: "Es sind leider keine Komfort-Upgrades vorhanden.",
    },
    en: {
      noServicesAvailableBanner: "No services are currently available.",
      noServicesAvailable: "No services available",
      ourServices: "Our services for your delivery",
      deliveryTimeUnknown: "Delivery time unknown",
      freeSlots: "available slots",
      oneFreeSlot: "available slot",
      alreadyBought: "Already purchased",
      newService: "new service",
      oldService: "old service",
      newSlot: "new date",
      oldSlot: "old date",
      slotReserved: "Already in cart",
      slotToCart: "Book preferred date",
      price: "Price:",
      cartError: "Cart error",
      addToCart: "Add to Cart",
      inCart: "In Cart",
      notBookable: "Not bookable",
      serviceBooked: "Service booked",
      adding: "Adding...",
      itemAdded: "Item added to cart!",
      loading: "Loading...",
      errorLoading: "Unfortunately, an error occurred while loading services.",
      errorLoadingData:
        "Unfortunately, there are no comfort upgrades available.",
    }
  };

  return texts[language] || texts["en"]; // Fallback to English
}

const currentTexts = getLanguageTexts();

function updateButtonState(button, isInCart, slotInCart) {
  const cutOff = button.getAttribute("data-cutoff");
  let firstSpan = button.getElementsByTagName('span')[0];
  if (cutOff && new Date(cutOff).getTime() < new Date().getTime()) {
    firstSpan.textContent = isInCart ? currentTexts.inCart : currentTexts.addToCart;
    button.disabled = true;
    button.classList.add('error-btn');
  } else if (slotInCart && cartStateManager.incompatibleServiceTags.includes(button.getAttribute("data-bundle-id"))) {
    firstSpan.textContent = currentTexts.notBookable;
    button.classList.add("booked-btn");
    button.disabled = true;
  } else if (isInCart) {
    firstSpan.textContent = currentTexts.inCart;
    button.classList.add("booked-btn");
    button.disabled = true;
    button.setAttribute("aria-label", currentTexts.inCart);
  } else {
    button.classList.remove("booked-btn");
    button.classList.remove("error-btn");
    firstSpan.textContent = currentTexts.addToCart;
    button.disabled = false;
    button.setAttribute("aria-label", currentTexts.addToCart);
  }
}

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function getShipmentNumber() {
  let shipmentNumber =
    getQueryParam("shipment") ||
    getQueryParam("shipmentNumber") ||
    getQueryParam("tracking");

  if (!shipmentNumber && typeof window.getPreservedShipment === "function") {
    shipmentNumber = window.getPreservedShipment();
  }

  return shipmentNumber;
}

/**
 * Register a cutoff countdown for a product
 */
function registerCutoff(cutoff, uniqueId) {
  if (!cutoff) return;
  const countdownDate = new Date(cutoff).getTime();
  const element = document.getElementById(uniqueId);
  if (!element) return;

  // Add countdown object
  cartStateManager.cutoffCountdowns.push({
    element,
    countdownDate,
    expired: false
  });
}

/**
 * Update all countdowns
 */
async function updateAllCutoffs() {
  const now = new Date().getTime();

  for (const item of cartStateManager.cutoffCountdowns) {
    if (item.expired) continue; // skip expired countdowns

    const distance = item.countdownDate - now;
    const {element} = item;

    if (distance < 0) {
      // Mark as expired
      item.expired = true;
      element.textContent = "Bestellfrist abgelaufen – kontaktiere bitte HES für deine Bestellung.";
      element.classList.add('cutoff-expired');
      // Refresh cart only once
      if (!cartStateManager.cartRefreshed && typeof refreshCartDrawer === 'function') {
        cartStateManager.cartRefreshed = true;
        await refreshCartDrawer(false);
      }
    } else {
      // Update countdown text
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      element.textContent = `${days} Tg., ${hours} Std., ${minutes} Min. und ${seconds} Sek. zum Bestellen!`;
    }
  }
}

function renderErrorContent(productsBox, errorContent, landingContainer) {
  productsBox.innerHTML = errorContent;
  landingContainer.querySelectorAll('.availability-text')
    .forEach(el => el.textContent = currentTexts.noServicesAvailable);
  landingContainer.querySelector('.landing-header').classList.remove('loading');

  const link = document.querySelector('.top-banner__link');
  if (link) {
    link.href = `https://myhes.de/`;
  }
}

function openPopup(elementId) {
  const popup = document.getElementById(elementId);
  popup.style.display = "block";
  document.body.style.overflow = "hidden";

  // focus on first element
  setTimeout(() => {
    const focusable = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable.length) focusable[0].focus();
  }, 10);

  // trap tab and esc-handling
  function trapTabKey(e) {
    if (e.key === 'Tab') {
      const focusable = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    } else if (e.key === 'Escape') {
      closePopup(elementId);
    }
  }
  popup.addEventListener('keydown', trapTabKey);
  popup._trapTabKey = trapTabKey;
}

function closePopup(elementId) {
  const popup = document.getElementById(elementId);
  popup.style.display = "none";
  document.body.style.overflow = "";
  // trap-tab-event removal
  if (popup._trapTabKey) popup.removeEventListener('keydown', popup._trapTabKey);
}

async function fetchAndRenderServices(shipmentNumber = null) {
  if (!shipmentNumber) {
    shipmentNumber = getShipmentNumber();
  }

  const landingContainer = document.getElementById('landing-container');
  const productsBox = document.getElementById('landing-product-box');
  const deliveryInfoContainer = document.querySelector('.delivery-info-container');
  const availableSlotsPopup = document.getElementById('available-slots-popup');
  const slotsContainer = document.getElementById("delivery-calendar");

  const closeBtn = document.getElementById('close-popup');
  const showSlotsBtn = document.getElementById('slots-popup-trigger');

  const errorContent = `<div class="landing-error">${currentTexts.noServicesAvailableBanner}</div>`;

  if (!shipmentNumber) {
    await cartStateManager.clearCart();
    renderErrorContent(productsBox, errorContent, landingContainer);
    return;
  }

  try {
    await cartStateManager.setShipmentNumber(shipmentNumber);
    const res = await fetch(`/apps/proxy/proxy-services?shipment=${encodeURIComponent(shipmentNumber)}`, {
      method: 'POST', headers: {
        'Content-Type': 'application/json'
      }
    });
    const data = await res.json();
    const shipmentTrackingNumber = data.shipmentData.shipmentTrackingNumber;
    productsBox.innerHTML = data.products.map(service =>
      `<div class="products-list">
        <h3 class="article-label">${service.service}</h3>
        <div class="products">
          ${service.details.map((details, index) => {
        let countdownHtml = '';
        if (!details.isBooked && details.cutoff) {
          const uniqueId = `cutoff-${service.service.replace(/\s+/g, '-')}-${details.bundleId}-${index}`;
          countdownHtml = `<span id="${uniqueId}" class="cutoff-countdown" data-cutofftime="${details.cutoff}"></span>`;
        }
        return `
          <div class="product-card${details.isBooked ? ' booked' : ''}">
            <div class="product-overlay">${service.service}</div>
            <a href="#" data-product-handle="${details.productHandle}">
              ${details.productImageUrl ? `<img src="${details.productImageUrl}" aria-hidden="true" class="product-image">` : ''}
              <div class="product-name">${details.productTitle}</div>
              <div class="product-description truncate-multiline">${details.productDescription}</div>
                       ${countdownHtml}
            </a>
            <div class="product-footer">
              <span class="product-price">${details.productPrice}</span>
              ${details.isBooked ? '<span class="to-cart-button booked-btn"></span>' : `
               <button class="to-cart-button"
                  data-variant-id="${details.variantId}"
                  data-contractor-id="${data.shipmentData.contractorId}"
                  data-service-for="${service.service}"
                  data-bundle-id="${details.bundleId}"
                  data-article-numbers='${JSON.stringify(details.articleNumbers)}'
                  data-cutoff="${details.cutoff || ''}"
                  data-contractor-item-reference="${details.contractorItemReference}">
                  <span></span>
                  <span class="hes-spinner"></span>
                </button>`}
            </div>
          </div>
          `;
      }).join('')}
        </div>
      </div>`
    ).join('');

    document.querySelectorAll('.cutoff-countdown').forEach(element => {
      registerCutoff(element.dataset.cutofftime, element.id);
    })

    let productCardNodes = productsBox.querySelectorAll('.product-card');
    const productCount = productCardNodes.length;
    if (productCount > 0) {
      landingContainer.querySelectorAll('.availability-icon-container').forEach(el => el.classList.add('available'));
      landingContainer.querySelectorAll('.availability-text')
        .forEach(el => el.innerHTML = `<span class="services-count highlight">${productCount}</span> Serviceleistung${productCount === 1 ? '' : 'en'} verfügbar`);
    } else {
      landingContainer.querySelectorAll('.availability-text')
        .forEach(el => el.innerHTML = `<span class="services-count highlight">keine</span> Serviceleistungen verfügbar`);
    }
    if (data.shipmentData.deliveryDate) {
      let deliveryDateText = new Date(data.shipmentData.deliveryDate).toLocaleDateString('de-DE', {
        weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric'
      });
      if (data.shipmentData.timeSlotStart && data.shipmentData.timeSlotEnd) {
        deliveryDateText = deliveryDateText + ", " + data.shipmentData.timeSlotStart + " - " + data.shipmentData.timeSlotEnd + " Uhr";
      }
      deliveryInfoContainer.querySelector('.delivery-date').textContent = deliveryDateText;
    } else {
      deliveryInfoContainer.querySelector('.delivery-date').textContent = currentTexts.deliveryTimeUnknown;
    }

    try {
      if (data.slots && data.slots.length > 0) {
        let depot = data.shipmentData.depot;
        if (depot) {
          let depotBox = document.getElementById("delivery-depot");
          depotBox.querySelector("#depot-tel").innerText = depot.phoneNumber;
          depotBox.querySelector("#depot-tel").setAttribute("href", "tel:" + depot.phoneNumber);
          depotBox.querySelector("#depot-opening-hours").innerText = depot.serviceHours;
          depotBox.querySelector("#depot-email").innerText = depot.email;
          depotBox.querySelector("#depot-email").setAttribute("href", "mailto:" + depot.email);
          depotBox.style.display = 'block';
        }
        document.querySelector('.free-delivery-badge').style.display = 'block';
        showSlotsBtn.style.display = 'inline-block';
        showSlotsBtn.addEventListener('click', async () => {
          slotsContainer.innerHTML = '';
          let incompatibleServices = await cartStateManager.getServicesIncompatibleWithSlots();
          renderDeliverySlots(data.slots, slotsContainer, shipmentNumber, incompatibleServices, shipmentTrackingNumber);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = deliveryInfoContainer.innerHTML;
          tempDiv.querySelectorAll('.popup-trigger, .banner-overlay').forEach(el => el.remove());
          availableSlotsPopup.querySelector('.available-slots-delivery-info').innerHTML = tempDiv.innerHTML;
          availableSlotsPopup.querySelector('.slots-count').textContent = data.slots.length;
          openPopup('available-slots-popup');
        });
        closeBtn.addEventListener('click', () => {
          cartStateManager.setSelectedSlot(null);
          closePopup('available-slots-popup');
        });
        availableSlotsPopup.querySelector('.popup-overlay').addEventListener('click', () => {
          cartStateManager.setSelectedSlot(null);
          closePopup('available-slots-popup');
        });
      }
    } catch (err) {
      console.error('Error setting up slots popup:', err);
    }

    await attachProductListeners(shipmentNumber);
    const buttons = productsBox.querySelectorAll('button.to-cart-button');
    await attachToCartButtonListeners(shipmentNumber, buttons, shipmentTrackingNumber);

    const link = document.querySelector('.top-banner__link');
    if (link) {
      link.href = `https://myhes.de/de/tracking/${encodeURIComponent(shipmentTrackingNumber)}`;
    }

  } catch (err) {
    console.error(err);
    renderErrorContent(productsBox, errorContent, landingContainer);
  }

  updateAllButtonStates();
  landingContainer.querySelector('.landing-header').classList.remove('loading');
}

let _slotBookingInFlight = false;

async function addSlotToCart(shipmentNumber, slotFromCart, selectedSlot, shipmentTrackingNumber) {
  if (_slotBookingInFlight) return;
  _slotBookingInFlight = true;
  try {
    const slotBookResponse = await fetch(`/apps/proxy/proxy-dod?terminId=${encodeURIComponent(selectedSlot.terminId)}&shipment=${encodeURIComponent(shipmentNumber)}&contractorId=${selectedSlot.contractorId}`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'}
    });

    if (!slotBookResponse.ok) throw new Error("Slot booking failed");

    const slotBookData = await slotBookResponse.json();
    if (!slotBookData?.reservierungsId) throw new Error("Invalid reservation ID");

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        attributes: {
          shipmentNumber: shipmentNumber,
          shipmentTrackingNumber: shipmentTrackingNumber
        },
        items: [{
          id: selectedSlot.variantId,
          quantity: 1,
          properties: {
            'Datum': selectedSlot.date,
            'Zeitfenster': `${selectedSlot.timeFrom} - ${selectedSlot.timeTo}`,
            '_reservationId': slotBookData.reservierungsId,
            '_contractorId': selectedSlot.contractorId,
            '_terminId': selectedSlot.terminId,
            _service_type: "Slot",
            _productTag: "DOD"
          }
        }]
      })
    });

    if (!response.ok) {
      // The new slot is already reserved on HES at this point; free it up rather
      // than leaving it orphaned since it never made it into the cart.
      await cancelOrphanedReservation(slotBookData.reservierungsId, selectedSlot.contractorId, shipmentNumber);
      throw new Error("Failed to add slot to cart");
    }

    if (slotFromCart) await cartStateManager.removeServiceFromCart(slotFromCart);

    await updateCartCount();
    await refreshCartDrawer(true);
    sessionStorage.setItem("slotReservationTimestamp", Date.now().toString());
    if (typeof window.renewReservation === 'function') {
      setInterval(() => window.renewReservation(), 60000);
    }
    document.dispatchEvent(new CustomEvent("cart:updated"));
  } catch (error) {
    console.error("Error adding slot to cart:", error);
    showSnackbar("Wunschtermin konnte nicht hinzugefügt werden. Bitte später erneut versuchen.");
  } finally {
    _slotBookingInFlight = false;
  }
  cartStateManager.setSelectedSlot(null);
}

async function cancelOrphanedReservation(reservationId, contractorId, shipmentNumber) {
  try {
    await fetch(`/apps/proxy/proxy-dod?reservationId=${encodeURIComponent(reservationId)}&contractorId=${contractorId}&shipment=${encodeURIComponent(shipmentNumber)}`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'}
    });
  } catch (error) {
    console.error("Error cancelling orphaned slot reservation:", error);
  }
}

function renderDeliverySlots(slots, container, shipmentNumber, incompatibleServices, shipmentTrackingNumber) {
  const confirmBtn = document.getElementById('confirm-slot');
  const cancelBtn = document.getElementById('close-slots-popup');

  if (cartStateManager.getSelectedSlot() === null) {
    let firstSpan = confirmBtn.getElementsByTagName('span')[0];
    firstSpan.textContent = "Bitte wähle einen Wunschtermin";
  }

  const incompatibleServicesText = document.getElementById('incompatible-services-text');
  let hasIncompatibleServices = incompatibleServices.length > 0;
  if (hasIncompatibleServices) {
    incompatibleServicesText.style.display = 'block';
    incompatibleServicesText.querySelector('.incompatible-services-list').innerHTML = incompatibleServices.map(s => `<li>${s.title}</li>`).join('');
  } else {
    incompatibleServicesText.style.display = 'none';
  }

  confirmBtn.disabled = true;
  confirmBtn.classList.remove('active');

  // --- Sort slots by date + time
  const sorted = slots.sort((a, b) => {
    if (a.liefertag === b.liefertag) return a.zeitVon.localeCompare(b.zeitVon);
    return a.liefertag.localeCompare(b.liefertag);
  });

  // --- Group slots by date
  const grouped = sorted.reduce((acc, slot) => {
    if (!acc[slot.liefertag]) acc[slot.liefertag] = [];
    acc[slot.liefertag].push(slot);
    return acc;
  }, {});

  // --- Create date select
  let selectElement = document.createElement("select");
  selectElement.className = "date-select";
  selectElement.setAttribute("aria-label", "Wunschdatum wählen");
  const groupedDates = Object.keys(grouped);
  if (groupedDates.length > 0) {
    const firstDate = groupedDates[0];
    const dateObj = new Date(firstDate);
    const dateFormatted = dateObj.toLocaleDateString("de-DE", {weekday: "short", day: "2-digit", month: "long"});
    const count = grouped[firstDate].length;
    const firstOption = document.createElement("option");
    firstOption.value = firstDate;
    firstOption.textContent = `${dateFormatted} (${count} ${count > 1 ? currentTexts.freeSlots : currentTexts.oneFreeSlot})`;
    selectElement.appendChild(firstOption);
    groupedDates.slice(1).forEach(date => {
      const dateObj = new Date(date);
      const dateFormatted = dateObj.toLocaleDateString("de-DE", {weekday: "short", day: "2-digit", month: "long"});
      const count = grouped[date].length;
      const option = document.createElement("option");
      option.value = date;
      option.textContent = `${dateFormatted} (${count} ${count > 1 ? currentTexts.freeSlots : currentTexts.oneFreeSlot})`;
      selectElement.appendChild(option);
    });
  }

  container.appendChild(selectElement);

  const timesContainer = document.createElement("div");
  timesContainer.className = "times-container";
  container.appendChild(timesContainer);

  cancelBtn.addEventListener('click', () => {
    closePopup('available-slots-popup');
    cartStateManager.setSelectedSlot(null);
  });

  if (hasIncompatibleServices) {
    selectElement.disabled = true;
    return;
  }
  selectElement.addEventListener("change", e => {
    cartStateManager.setSelectedSlot(null);
    confirmBtn.disabled = true;
    confirmBtn.classList.remove('active');
    let firstSpan = confirmBtn.getElementsByTagName('span')[0];
    firstSpan.textContent = "Bitte wähle einen Wunschtermin";
    renderTimes(e.target.value, grouped, timesContainer);
  });
  const freshConfirmBtn = confirmBtn.cloneNode(true);
  confirmBtn.replaceWith(freshConfirmBtn);

  // Only render the first date's slots after confirmBtn has been replaced above, otherwise
  // selectSlot() enables a detached clone that's no longer the button shown in the popup.
  if (groupedDates.length > 0) {
    renderTimes(groupedDates[0], grouped, timesContainer);
  }

  freshConfirmBtn.addEventListener('click', async () => {
    let selectedSlot = cartStateManager.getSelectedSlot();
    if (selectedSlot === null) return;
    const slotFromCart = cartStateManager.isSlotInCart();
    freshConfirmBtn.classList.add('loading-button');
    freshConfirmBtn.disabled = true;
    try {
      if (slotFromCart) {
        closePopup('available-slots-popup');
        showSlotReplacementPopup(shipmentNumber, slotFromCart, selectedSlot, shipmentTrackingNumber);
      } else {
        await addSlotToCart(shipmentNumber, null, selectedSlot, shipmentTrackingNumber);
      }
    } catch (error) {
      console.error('Error updating cart state before slot addition:', error);
    }
    closePopup('available-slots-popup');
    freshConfirmBtn.disabled = false;
    freshConfirmBtn.classList.remove('loading-button');
  });
}

function renderTimes(date, grouped, timesContainer) {
  const confirmBtn = document.getElementById('confirm-slot');
  timesContainer.innerHTML = "";
  if (!date) return;

  const slotFromCart = cartStateManager.isSlotInCart();

  grouped[date].forEach(slot => {
    const slotBox = document.createElement("div");
    let formattedDate = new Date(slot.liefertag).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    slotBox.className = "time-slot";
    slotBox.innerHTML = `<div>${formattedDate}</div><div>${slot.zeitVon} – ${slot.zeitBis}</div><div class="highlight"><strong>${slot.price ? slot.price : ""}</strong></div>`;
    slotBox.dataset.variantid = slot.variantId;
    slotBox.dataset.terminid = slot.terminId;
    slotBox.dataset.contractorid = slot.contractorId;
    slotBox.setAttribute('tabindex', '0');
    slotBox.setAttribute('role', 'button');
    slotBox.setAttribute('aria-label', `Liefertermin ${formattedDate}, ${slot.zeitVon} bis ${slot.zeitBis}${slot.price ? ', Preis: ' + slot.price : ''}`);

    function selectSlot() {
      if (slotBox.classList.contains("selected")) {
        slotBox.classList.remove("selected");
        cartStateManager.setSelectedSlot(null);
        let firstSpan = confirmBtn.getElementsByTagName('span')[0];
        firstSpan.textContent = "Bitte wähle einen Wunschtermin";
        confirmBtn.disabled = true;
        confirmBtn.classList.remove('active');
        return;
      }
      document.querySelectorAll(".time-slot").forEach(el => el.classList.remove("selected"));
      slotBox.classList.add("selected");
      let selectedSlot1 = cartStateManager.setSelectedSlot({
        date: formattedDate,
        timeFrom: slot.zeitVon,
        timeTo: slot.zeitBis,
        variantId: slot.variantId,
        terminId: slot.terminId,
        contractorId: slot.contractorId
      });

      let firstSpan = confirmBtn.getElementsByTagName('span')[0];
      firstSpan.textContent = "Wunschtermin: " + selectedSlot1.date + ", " + selectedSlot1.timeFrom + " - " + selectedSlot1.timeTo + " Uhr reservieren";
      confirmBtn.disabled = false;
      confirmBtn.classList.add('active');
    }

    if (slotFromCart && slotFromCart.properties['_terminId'] === slot.terminId) {
      let node = document.createElement("div");
      node.className = "reserved-slot";
      node.textContent = currentTexts.slotReserved;
      slotBox.appendChild(node);
      slotBox.setAttribute('aria-disabled', 'true');
      slotBox.setAttribute('tabindex', '-1');
    } else {
      slotBox.addEventListener("click", selectSlot);
      slotBox.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          selectSlot();
        }
      });
    }

    timesContainer.appendChild(slotBox);
  });
}

async function attachProductListeners(shipmentNumber) {
  const productPopupContainer = document.getElementById("product-popup");

  document.querySelectorAll('.product-card a').forEach(link => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();

      const modalBody = productPopupContainer.querySelector('#product-info');
      const productCard = link.closest('.product-card');
      if (!productCard || !modalBody) return;

      // Clear previous modal content
      modalBody.innerHTML = '';

      // Clone the product card
      const productClone = productCard.cloneNode(true);
      productClone.querySelector('.product-description')?.classList.remove('truncate-multiline');
      productClone.querySelector('.cutoff-countdown')?.remove();
      const cutoffCountdown = productClone.querySelector('.cutoff-countdown');
      if (cutoffCountdown) {
        cutoffCountdown.remove();
      }
      modalBody.appendChild(productClone);

      // Re-attach Add to Cart listeners to the cloned buttons
      const clonedButtons = productClone.querySelectorAll('button.to-cart-button');
      if (clonedButtons.length) {
        clonedButtons.forEach(btn => btn.dataset.cartListenerAttached = '0'); // reset
        await attachToCartButtonListeners(shipmentNumber, clonedButtons);
      }

      // Open modal
      openPopup("product-popup");
    });
  });

  // Close modal
  productPopupContainer.querySelector('.popup-close')
    .addEventListener('click', () => closePopup("product-popup"));

  productPopupContainer.querySelector('.popup-overlay')
    .addEventListener('click', () => closePopup("product-popup"));
}

async function attachToCartButtonListeners(shipmentNumber, buttons, shipmentTrackingNumber) {
  try {
    // Make listener attachment idempotent: skip buttons that already have a listener
    for (const btn of buttons) {
      if (btn.dataset.cartListenerAttached === '1') continue;
      const handler = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;

        btn.classList.add('loading-button');
        btn.disabled = true;
        const {serviceFor = '', bundleId = '', contractorItemReference} = btn.dataset;
        const isAltService = (bundleId || '').toLowerCase().includes('-alt');
        const existingService = isAltService
          ? cartStateManager.getAltServiceInCart(serviceFor, contractorItemReference)
          : cartStateManager.getNonAltServiceInCart(serviceFor, contractorItemReference);

        if (existingService) {
          closePopup("product-popup");
          showProductReplacementPopup(shipmentNumber, btn, existingService, isAltService, shipmentTrackingNumber);
        } else {
          await performCartAddition(shipmentNumber, btn, existingService, isAltService, shipmentTrackingNumber);
        }
        btn.classList.remove('loading-button');
        btn.disabled = false;
        closePopup("product-popup");
      };
      btn.addEventListener('click', handler);
      // mark as attached to avoid duplicate listeners on subsequent calls
      btn.dataset.cartListenerAttached = '1';
    }
  } catch (error) {
    console.error('Error on to-cart-button:', error);
  }
}

async function updateCartCount() {
  try {
    const response = await fetch("/?section_id=header");
    const html = await response.text();

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const newCartIcon = tempDiv.querySelector(
      ".header__icon--cart, .cart-icon, [data-cart-count]"
    );
    const currentCartIcon = document.querySelector(
      ".header__icon--cart, .cart-icon, [data-cart-count]"
    );

    if (newCartIcon && currentCartIcon) {
      currentCartIcon.innerHTML = newCartIcon.innerHTML;

      Array.from(newCartIcon.attributes).forEach((attr) => {
        currentCartIcon.setAttribute(attr.name, attr.value);
      });
    } else {
      console.warn("Could not find cart icon elements");
    }
  } catch (error) {
    console.error("Error updating cart count:", error);
  }
}

class CartStateManager {
  constructor() {
    this.cartItems = [];
    this.observers = [];
    this.currentShipmentNumber = null;
    this.selectedSlot = null;
    this.cutoffCountdowns = [];
    this.cartRefreshed = false;
    this.incompatibleServiceTags = ["MOE-003", "SP-003", "SP-003-VA1", "SP-003-VA7", "TV-004", "TV-004-VA1",
      "TV-004-VA7", "TV-005-VA1", "TV-005-VA7", "TV-006", "TV-006-VA1", "TV-006-VA7",
      "WW-005", "WW-005-VA1", "WW-005-VA7", "WW-006", "WW-006-VA1", "WW-006-VA7", "WW-007", "WW-007-VA1", "WW-007-VA7"];
  }

  subscribe(callback) {
    this.observers.push(callback);
  }

  notify() {
    this.observers.forEach((callback) => callback(this.cartItems));
  }

  async setShipmentNumber(shipmentNumber) {
    const previousShipmentNumber = sessionStorage.getItem(
      "currentShipmentNumber"
    );
    if (previousShipmentNumber && previousShipmentNumber !== shipmentNumber) {
      await this.clearCart();
      await new Promise((resolve) => setTimeout(resolve, 300));
    }

    this.currentShipmentNumber = shipmentNumber;
    sessionStorage.setItem("currentShipmentNumber", shipmentNumber);

    await this.updateCartState();
    this.notify();
    await updateCartCount();
  }

  initializeShipmentNumber(shipmentNumber) {
    if (this.currentShipmentNumber === null) {
      this.currentShipmentNumber = shipmentNumber;
    }
  }

  async clearCart() {
    try {
      const response = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        this.cartItems = [];

        this.notify();

        await updateCartCount();
        await refreshCartDrawer(false);

        return true;
      } else {
        console.error("Failed to clear cart:", response.status);
        return false;
      }
    } catch (error) {
      console.error("Error clearing cart:", error);
      return false;
    }
  }

  async updateCartState() {
    try {
      const cartData = await fetch("/cart.js").then((res) => res.json());
      this.cartItems = cartData.items || [];
      this.notify();
      return this.cartItems;
    } catch (error) {
      console.error("Error updating cart state:", error);
      return [];
    }
  }

  isAltService(item) {
    if (item.properties && item.properties["_service_type"]) {
      return item.properties["_service_type"] === "ALT";
    }

    return item.product_tags && item.product_tags.toLowerCase().includes("-alt");
  }

  isItemInCart(variantId, bundleId, serviceFor, contractorItemReference) {
    return this.cartItems.some(
      (item) =>
        item.variant_id === variantId &&
        item.properties &&
        item.properties["Zusatzservice für"] === serviceFor &&
        item.properties["_contractorItemReference"] === contractorItemReference
    );
  }

  isSlotInCart() {
    return this.cartItems.find(
      (item) =>
        item.properties &&
        item.properties["_service_type"] === "Slot"
    );
  }

  async getServicesIncompatibleWithSlots() {
    const cartItems = await this.updateCartState();
    return cartItems.filter(item => item.properties && this.incompatibleServiceTags.includes(item.properties["_productTag"]));
  }

  getAltServiceInCart(serviceFor, contractorItemReference) {
    return this.cartItems.find(
      (item) =>
        item.properties &&
        item.properties["Zusatzservice für"] === serviceFor &&
        item.properties["_contractorItemReference"] === contractorItemReference &&
        this.isAltService(item)
    );
  }

  getNonAltServiceInCart(serviceFor, contractorItemReference) {
    return this.cartItems.find(
      (item) =>
        item.properties &&
        item.properties["Zusatzservice für"] === serviceFor &&
        item.properties["_contractorItemReference"] === contractorItemReference &&
        !this.isAltService(item)
    );
  }

  async removeServiceFromCart(existingService) {
    try {
      if (existingService) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: existingService.key,
            quantity: 0,
          }),
        });
      }
    } catch (error) {
      console.error("Error removing ALT services from cart:", error);
    }
  }

  setSelectedSlot(slot) {
    this.selectedSlot = slot;
    return this.selectedSlot;
  }

  getSelectedSlot() {
    return this.selectedSlot;
  }

  clearSelectedSlot() {
    this.selectedSlot = null;
  }
}

const cartStateManager = new CartStateManager();

function updateAllButtonStates() {
  document.querySelectorAll("button.to-cart-button").forEach((button) => {
    const serviceFor = button.getAttribute("data-service-for");
    const variantId = parseInt(button.getAttribute("data-variant-id"));
    const bundleId = button.getAttribute("data-bundle-id");
    const contractorItemReference = button.getAttribute("data-contractor-item-reference");
    const isInCart = cartStateManager.isItemInCart(
      variantId,
      bundleId,
      serviceFor,
      contractorItemReference
    );
    const slotInCart = cartStateManager.isSlotInCart();
    updateButtonState(button, isInCart, slotInCart);
  });
  document.querySelectorAll("span.to-cart-button").forEach((button) => {
    button.textContent = currentTexts.alreadyBought;
  });
}

function setupCartChangeListeners() {
  document.addEventListener("cart:updated", () => {
    cartStateManager.updateCartState();
  });

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      clearTimeout(observer.timeoutId);
      observer.timeoutId = setTimeout(() => {
        cartStateManager.updateCartState();
      }, 300);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  cartStateManager.subscribe(updateAllButtonStates);
}

async function handleShipmentChange() {
  const currentShipmentNumber = getShipmentNumber();

  if (cartStateManager.currentShipmentNumber !== currentShipmentNumber) {
    await fetchAndRenderServices(currentShipmentNumber);
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  setupCartChangeListeners();

  await cartStateManager.updateCartState();

  await fetchAndRenderServices();
  setInterval(updateAllCutoffs, 1000);

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      handleShipmentChange();
    }
  });

  window.addEventListener("popstate", handleShipmentChange);

  window.showSnackbar = function (message = "Ein Fehler ist aufgetreten.") {
    const bar = document.getElementById("snackbar");
    if (!bar) return;
    bar.textContent = message;
    bar.classList.add("show");
    setTimeout(() => {
      bar.classList.remove("show");
    }, 5000);
  }
});
